import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import type { PageType } from '../AccountDashboard'
import DropdownTop from './Dropdown/Top'
import DropdownBottom from './Dropdown/Bottom'
import LogoutIcon from 'assets/logout.svg'
import useAccount from 'hooks/account/useAccount'
import Link from 'theme/atoms/Link'
import useTranslations from 'hooks/useTranslations'
export type Props = {
  activePage: PageType
}

export default function MobileDropdown(props: Props) {
  const t = useTranslations<'app-AccountDashboard'>()
  const account = useAccount()
  const { firstName = '', lastName = '' } = account.context || {}
  return (
    <Wrapper className="MobileDropdown">
      <DropdownTop activePage={props.activePage} />
      <DropdownBottom activePage={props.activePage} />

      <div className="infos">
        <div className="left">
          <div className="row">
            <span className="label">{t('dashboard_log_in_as')}</span>
            <span className="value">
              {firstName} {lastName}
            </span>
          </div>

          {!account.context?.customerNumber.startsWith('SW') && (
            <div className="row" data-cy-state="show-customer-number">
              <span className="label">{t('dashboard_customer_no')}</span>
              <span className="value">{account.context?.customerNumber}</span>
            </div>
          )}
        </div>
        <div
          className="logout"
          data-cy-handle="mobile-logout-btn"
          onClick={account.logout}
        >
          <LogoutIcon />
          {t('dashboard_log_out')}
        </div>
      </div>
      <div className="teasers">
        <div className="service-box">
          {t('dashboard_sidebar_image1', {
            IMAGE: '_',
            __transformers: {
              IMAGE: (_, vars) => (
                <Link className="img-box" to={vars.IMAGE_link}>
                  <img
                    src={vars.IMAGE_path}
                    alt={vars.IMAGE_alt}
                    width={90}
                    height={68}
                  />
                  <div className="info">
                    <div className="title">
                      {t('dashboard_help_and_service')}
                    </div>
                    <div className="desc">{t('dashboard_order_info_text')}</div>
                  </div>
                </Link>
              )
            }
          })}
        </div>
        <div className="service-box">
          {t('dashboard_sidebar_image2', {
            IMAGE: '_',
            __transformers: {
              IMAGE: (_, vars) => (
                <Link className="img-box" to={vars.IMAGE_link}>
                  <img
                    src={vars.IMAGE_path}
                    alt={vars.IMAGE_alt}
                    width={90}
                    height={68}
                  />
                  <div className="info">
                    <div className="title">
                      {t('dashboard_payback_program')}
                    </div>
                    <div className="desc">
                      {t('dashboard_payback_program_text')}
                    </div>
                  </div>
                </Link>
              )
            }
          })}
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > .Dropdown {
    margin-bottom: ${theme.spacing('s')};
  }

  > .infos {
    margin-bottom: ${theme.spacing('l')};
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    > .left {
      display: flex;
      flex-direction: column;
      gap: ${theme.spacing('xs')};

      > .row {
        ${theme.ty('rc-s')};
        > .label {
          font-weight: bold;
          margin-right: ${theme.spacing('xs')};
        }
      }
    }

    > .logout {
      cursor: pointer;
      display: flex;
      align-items: center;
      > svg {
        width: 1.125rem;
        height: 1.125rem;
        margin-right: 0.5rem;
      }
      ${theme.ty('rc-s', 'bold')}
      text-decoration: underline;
    }
  }

  > .teasers {
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing('m')};
    margin-bottom: ${theme.spacing('l')};
    > .service-box {
      > span {
        > span {
          > .img-box {
            background: ${theme.colors.shade.b7};
            padding: ${theme.spacing('xs')};
            display: flex;
            flex-direction: column;
            @media (min-width: ${theme.ms.MD}px) {
              flex-direction: row;
            }
            > img {
              height: 6rem;
              width: 9.375rem;
              margin-right: ${theme.spacing('xs')};
              margin-bottom: ${theme.spacing('xs')};
            }
            > .info {
              flex: 1;
              > .title {
                ${theme.ty('rc-s', 'bold')}
                margin-bottom: ${theme.spacing('xxs')};
              }
              > .desc {
                ${theme.ty('rc-s')}
              }
            }
          }
        }
      }
    }
  }
`
